const OPEN_DEEPLINK_BANNER = '@@OPEN_DEEPLINK_BANNER';
const CLOSE_DEEPLINK_BANNER = '@@CLOSE_DEEPLINK_BANNER';

export function closeDeeplinkBanner() {
  return {
    type: CLOSE_DEEPLINK_BANNER,
  };
}

export function updateBanner(value) {
  return {
    type: OPEN_DEEPLINK_BANNER,
    value,
  };
}

export function overlaysReducer(state = {deeplinkBanner: null, userClosed: false}, action) {
  switch (action.type) {
    case CLOSE_DEEPLINK_BANNER:
      return {...state, open: false, userClosed: true};
    case OPEN_DEEPLINK_BANNER:
      if (state.userClosed) {
        return state;
      }
      return {...state, open: true, deeplinkBanner: action.value};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ../src/client/state/overlays.js